export const READ_CURRENT_PAGE_TOOL = 'read_current_page';

/** Most characters of page text the CRM sends back. */
export const READ_CURRENT_PAGE_MAX_CHARS = 12_000;

export type ReadCurrentPageOutput =
  | {
      ok: true;
      /** In-app path and query string of the page that was read. */
      url: string;
      /** Visible text of the page, without the chat panel. */
      text: string;
      /** True when `text` was cut at READ_CURRENT_PAGE_MAX_CHARS. */
      truncated: boolean;
    }
  | { ok: false; error: string };
